"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loading;

var _loadingStore = _interopRequireWildcard(require("./loadingStore"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// lowercase the first
function lowerCaseFirst(str) {
  if (str === null) {
    return '';
  }

  str = String(str);
  return str.charAt(0).toLowerCase() + str.substr(1);
}
/**
 * execute action
 * @param names [model, action]
 * @param func
 * @param scope
 * @returns {function(): *}
 */


function executeAction(names, func, scope) {
  return function () {
    var _names = _slicedToArray(names, 2),
        model = _names[0],
        action = _names[1];

    _loadingStore.default.change(model, action, true);

    var promise = func.apply(scope || this, arguments); // hope is a promise object

    if (_typeof(promise) === 'object' && typeof promise.finally === 'function') {
      promise.finally(function () {
        _loadingStore.default.change(model, action, false);
      });
    } else {
      _loadingStore.default.change(model, action, false);
    }

    return promise;
  };
}

function actionDecorator(target, prop, descriptor, name) {
  var names;

  if (typeof name === 'undefined' && target.constructor && typeof target.constructor.name === 'string') {
    if (target.namespace) {
      name = target.namespace;
      prop = lowerCaseFirst(prop);
    } else {
      name = lowerCaseFirst(target.constructor.name);
      prop = lowerCaseFirst(prop);
    }

    names = [name, lowerCaseFirst("".concat(name).concat(_loadingStore.NAMESPACE_SEP).concat(prop))];
  } else if (Array.isArray(name)) {
    names = [name[0], name.length > 1 ? name.join(_loadingStore.NAMESPACE_SEP) : null];
  } else {
    name = String(name).split(_loadingStore.NAMESPACE_SEP);
    names = [name[0], name.length > 1 ? name.join(_loadingStore.NAMESPACE_SEP) : null];
  }

  if (descriptor) {
    if (process.env.NODE_ENV !== "production" && descriptor.get !== undefined) {
      throw new Error("@loading cannot be used with getters");
    } // babel / typescript
    // @action method() { }


    if (descriptor.value) {
      // typescript
      return {
        value: executeAction(names, descriptor.value),
        enumerable: false,
        configurable: true,
        // See #1477
        writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)

      };
    } // babel only: @action method = () => {}


    var _initializer = descriptor.initializer;
    return {
      enumerable: false,
      configurable: true,
      // See #1477
      writable: true,
      // See #1398
      initializer: function initializer() {
        // N.B: we can't immediately invoke initializer; this would be wrong
        return executeAction(names, _initializer.call(this));
      }
    };
  } // bound loadingStore methods


  return fieldActionDecorator(names).apply(this, arguments);
}

function fieldActionDecorator(name) {
  // Simple property that writes on first invocation to the current loadingStore
  return function (target, prop, descriptor) {
    Object.defineProperty(target, prop, {
      configurable: true,
      enumerable: false,
      get: function get() {
        return undefined;
      },
      set: function set(value) {// 待实现
      }
    });
  };
}

function loading() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1) {
    return function (target, prop, descriptor) {
      return actionDecorator(target, prop, descriptor, args[0]);
    };
  } else {
    return actionDecorator.apply(this, args);
  }
}